import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=92241ada&"
import script from "./NewsSection.vue?vue&type=script&lang=js&"
export * from "./NewsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\marci\\Desktop\\majorel-china-static\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92241ada')) {
      api.createRecord('92241ada', component.options)
    } else {
      api.reload('92241ada', component.options)
    }
    module.hot.accept("./NewsSection.vue?vue&type=template&id=92241ada&", function () {
      api.rerender('92241ada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/templates/NewsSection.vue"
export default component.exports